import './components/index.scss'
import { lazy, Suspense } from "react";
import { BrowserRouter } from 'react-router-dom';
import CustomProvider, { contexto } from './components/CustomProvider';
import DeviceManager from './components/DeviceManager';
import KeepAlive from './components/KeepAlive';
import { Route, Routes } from "react-router-dom";
import Error from "./components/Error"
import Principal from "./components/Principal";
const AdminPanel = lazy(() => import("./components/Admin/AdminPanel"));


function App() {

  return (
    <CustomProvider>
      <BrowserRouter>
        <DeviceManager />
        <KeepAlive />
        <Routes>
          <Route path="/" element={<Principal />} />
          <Route
            path="/admin"
            element={
              <Suspense fallback={<div>Cargando panel admin...</div>}>
                <AdminPanel />
              </Suspense>
            }
          />

          {/* <Route path="/horoscopos" element={<Horoscopos />} /> */}
          {/* <Route path="/noticias" element={<Noticias />} /> */}
          <Route path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </CustomProvider>
  );
}


export default App;
